export const softDeleteData = () => ({
    is_active: { set: false },
    deleted_at: { set: new Date().toISOString() },
});

export const restoreData = () => ({
    is_active: { set: true },
    deleted_at: { set: null },
});
